import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DeceasedTriggerName } from './deceased-workflow';

export { DeceasedTriggerName } from './deceased-workflow';

export class DeceasedTrigger {
    static readonly DECEASED_STATE_CHANGED = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_STATE_CHANGED,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_state_changed'
                description='The displayed value for the DeceasedTrigger deceased_state_changed'
                defaultMessage='Deceased state changed'
            />
        )
    );
    static readonly DECEASED_REGISTER = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_REGISTER,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_register'
                description='The displayed value for the DeceasedTrigger deceased_register'
                defaultMessage='Register deceased'
            />
        )
    );
    static readonly DECEASED_RECEIVE = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_RECEIVE,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_receive'
                description='The displayed value for the DeceasedTrigger deceased_receive'
                defaultMessage='Receive deceased'
            />
        )
    );
    static readonly DECEASED_SCHEDULE_CREMATION = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_SCHEDULE_CREMATION,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_schedule_cremation'
                description='The displayed value for the DeceasedTrigger deceased_schedule_cremation'
                defaultMessage='Schedule cremation'
            />
        )
    );
    static readonly DECEASED_START_CREMATION = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_START_CREMATION,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_start_cremation'
                description='The displayed value for the DeceasedTrigger deceased_start_cremation'
                defaultMessage='Start cremation'
            />
        )
    );
    static readonly DECEASED_COMPLETE_CREMATION = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_COMPLETE_CREMATION,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_complete_cremation'
                description='The displayed value for the DeceasedTrigger deceased_complete_cremation'
                defaultMessage='Complete cremation'
            />
        )
    );
    static readonly DECEASED_RELEASE = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_RELEASE,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_release'
                description='The displayed value for the DeceasedTrigger deceased_release'
                defaultMessage='Release deceased'
            />
        )
    );
    static readonly DECEASED_CANCEL = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_CANCEL,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_cancel'
                description='The displayed value for the DeceasedTrigger deceased_cancel'
                defaultMessage='Cancel deceased'
            />
        )
    );
    static readonly DECEASED_IDENTIFICATION_SCANNED = new DeceasedTrigger(
        DeceasedTriggerName.DECEASED_IDENTIFICATION_SCANNED,
        (
            <FormattedMessage
                id='DeceasedTrigger.deceased_identification_scanned'
                description='The displayed value for the DeceasedTrigger deceased_identification_scanned'
                defaultMessage='Identification scanned'
            />
        )
    );

    static readonly ALL = [
        DeceasedTrigger.DECEASED_STATE_CHANGED,
        DeceasedTrigger.DECEASED_REGISTER,
        DeceasedTrigger.DECEASED_RECEIVE,
        DeceasedTrigger.DECEASED_SCHEDULE_CREMATION,
        DeceasedTrigger.DECEASED_START_CREMATION,
        DeceasedTrigger.DECEASED_COMPLETE_CREMATION,
        DeceasedTrigger.DECEASED_RELEASE,
        DeceasedTrigger.DECEASED_CANCEL,
        DeceasedTrigger.DECEASED_IDENTIFICATION_SCANNED
    ];

    constructor(
        public readonly value: DeceasedTriggerName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(trigger: string): DeceasedTrigger | undefined {
        return this.ALL.find((item) => item.value === trigger);
    }
}
